import { ExternalLink } from "lucide-react";
import { Logo } from "@/components/Logo";

const GESTIONALE_URL = "https://tour-operator-demo.emergent.host";

export default function GestionaleLink() {
    return (
        <div data-testid="gestionale-link-page" className="min-h-screen bg-[#0B0C0E] flex items-center justify-center px-5">
            <div className="w-full max-w-md rounded-xl border border-amber-500/25 bg-[#14161B] p-10 text-center">
                <div className="flex justify-center"><Logo /></div>
                <h1 className="mt-8 font-display text-2xl text-amber-50">Gestionale Tourvoyagers</h1>
                <p className="mt-3 text-sm text-stone-400 leading-relaxed">
                    Catalogo, pacchetti, immagini, prenotazioni e voucher sono gestiti esclusivamente dal gestionale Tourvoyagers ufficiale.
                    Questo sito pubblico vi si collega in sola lettura e registrazione richieste.
                </p>
                <a
                    href={GESTIONALE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="gestionale-open-button"
                    className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber-400 px-8 py-3 text-xs font-bold uppercase tracking-[0.14em] text-black transition-colors hover:bg-amber-300"
                >
                    Apri il gestionale <ExternalLink size={14} />
                </a>
            </div>
        </div>
    );
}
